// extracted by mini-css-extract-plugin
export default {"menu_portal":"HamburgerMenu_menu_portal__rXIFg","isOpen":"HamburgerMenu_isOpen__OtiAK","overlay":"HamburgerMenu_overlay__1QXjV"};